import { useFetch } from "../useFetch";
import { UseFetchProps } from "../types";

type UseDeleteOptions<T> = Pick<UseFetchProps<T>, "skipAuth" | "url">;

export function useDelete<T>(options?: UseDeleteOptions<T>) {
  return useFetch<T>({
    method: "DELETE",
    serializer: () => null,
    ...options,
  });
}
